(function () {
  'use strict';
  if (window.AnomFunnelDiagnostics) return;
  var allowed = ['view', 'config_view', 'summary_view', 'configure', 'checkout_start', 'checkout_slow', 'checkout_redirect', 'checkout_error'];
  var stages = ['cart_read', 'cart_update', 'cart_add'];
  var seen = new Set();
  function permitted() {
    try { return window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'yes'; }
    catch (_) { return false; }
  }
  function emit(name, stage, elapsed) {
    if (!allowed.includes(name) || !permitted() || typeof window.clarity !== 'function') return false;
    try {
      // Only fixed categories: no customer identifiers, URLs or error messages.
      window.clarity('set', 'anom_funnel_version', 'cro-20260914');
      window.clarity('set', 'anom_theme_mode', window.Shopify?.theme?.role === 'main' ? 'live' : 'preview');
      window.clarity('set', 'anom_viewport', window.innerWidth < 750 ? 'mobile' : window.innerWidth < 1100 ? 'tablet' : 'desktop');
      if (stages.includes(stage)) window.clarity('set', 'anom_cart_stage', stage);
      if (Number.isFinite(elapsed)) window.clarity('set', 'anom_checkout_delay', elapsed < 2000 ? 'under_2s' : elapsed < 5000 ? '2_to_5s' : 'over_5s');
      window.clarity('event', 'anom_' + name);
      return true;
    } catch (_) { return false; }
  }
  window.AnomFunnelDiagnostics = { emit: emit };
  function once(name) { if (!seen.has(name) && emit(name)) seen.add(name); }
  function init() {
    var root = document.querySelector('.anom-funnel');
    if (!root) return;
    var targets = [['config_view', root.querySelector('.anom-funnel__grid')], ['summary_view', root.querySelector('.js-funnel-submit')]];
    function visibleViews() {
      once('view');
      targets.forEach(function (entry) {
        if (!entry[1]) return;
        var r = entry[1].getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) once(entry[0]);
      });
    }
    visibleViews();
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var target = targets.find(function (t) { return t[1] === entry.target; });
            if (target) once(target[0]);
          }
        });
      }, { threshold: 0.1 });
      targets.forEach(function (t) { if (t[1]) observer.observe(t[1]); });
    }
    document.addEventListener('visitorConsentCollected', visibleViews);
    root.addEventListener('click', function (event) {
      var choice = event.target.closest('.js-funnel-choice');
      if (!choice || !root.contains(choice)) return;
      var group = choice.dataset.group;
      if (!['format', 'brew', 'style', 'size'].includes(group)) return;
      if (emit('configure')) {
        try { window.clarity('set', 'anom_choice_group', group); } catch (_) {}
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
